import { render, staticRenderFns } from "./AzallKategori.vue?vue&type=template&id=d676db0e&scoped=true"
import script from "./AzallKategori.vue?vue&type=script&lang=js"
export * from "./AzallKategori.vue?vue&type=script&lang=js"
import style0 from "./AzallKategori.vue?vue&type=style&index=0&id=d676db0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d676db0e",
  null
  
)

export default component.exports